"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _MenuContext = require("./MenuContext");
var _excluded = ["className", "style", "title", "icon", "children", "opened", "onOpenedChange"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var SubMenu = function SubMenu(props) {
  var className = props.className,
    style = props.style,
    title = props.title,
    icon = props.icon,
    children = props.children,
    _opened = props.opened,
    _onOpenedChange = props.onOpenedChange,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('menu');
  var _ref = Array.isArray(icon) ? icon : [icon, icon],
    _ref2 = (0, _slicedToArray2.default)(_ref, 2),
    defaultIcon = _ref2[0],
    activeIcon = _ref2[1];
  // 子菜单被选中项
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedId = _useState2[0],
    setSelectedId = _useState2[1];
  var _useState3 = (0, _react.useState)(_opened),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    opened = _useState4[0],
    onOpenedChange = _useState4[1];

  // 优化组件存在，opened值无法改变问题
  (0, _react.useEffect)(function () {
    onOpenedChange(_opened);
  }, [_opened]);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)("".concat(prefixCls, "__item"), "".concat(prefixCls, "__submenu"), {
      'is-selected': !!selectedId && !opened,
      'is-expanded': opened
    })
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "".concat(prefixCls, "__link"),
    onClick: function onClick() {
      onOpenedChange(!opened);
      !!_onOpenedChange && _onOpenedChange(!opened);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__icon")
  }, !!defaultIcon && (typeof defaultIcon === 'string' ? /*#__PURE__*/_react.default.createElement("img", {
    src: defaultIcon,
    alt: "icon"
  }) : defaultIcon), !!activeIcon && (typeof activeIcon === 'string' ? /*#__PURE__*/_react.default.createElement("img", {
    className: "is-selected",
    src: activeIcon,
    alt: "icon"
  }) : activeIcon)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__text")
  }, title)), /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(prefixCls, "__list")
  }, /*#__PURE__*/_react.default.createElement(_MenuContext.SubMenuContext.Provider, {
    value: {
      inSubMenu: true,
      onSelectedChange: function onSelectedChange(id, selected) {
        return setSelectedId(function (selectedId) {
          if (selected) {
            return id;
          }
          if (id === selectedId) {
            return null;
          }
          return selectedId;
        });
      }
    }
  }, children)));
};
var _default = SubMenu;
exports.default = _default;